
import * as _ from "lodash";
import * as codes from "./define/codes";
import { Util } from "./util";

/** */
export type SessionLoginUserInfo = {
    /** ユーザID(管理者の場合はAdminUserIdが入る) */
    UserId: number;
    /** プロジェクトID(管理者の場合は空)*/
    ProjectId?: number;
    /** 会社ID(管理者の場合は空)*/
    CompanyId?: number;
    /** ログインID*/
    LoginId: string;
    /** ユーザID（S-TORAGE）*/
    StorageUserId: string;
    /** ユーザ名*/
    UserName: string;
    /** 表示名*/
    DispName: string;
    /** サイン名*/
    SignName: string;
    /** 権限区分*/
    AuthDiv: codes.AuthDiv;
    /** 機器作業操作区分 */
    EquipmentWorkOperationDiv: codes.EquipmentWorkOperationDiv;
    /** パスワード変更要否フラグ*/
    PasswordChangeNecessityFlg?: boolean;
    /** 備考*/
    Remarks: string;
    /** 管理者フラグ（システム管理者、プロジェクト管理者）*/
    //IsAdminUser: boolean;
    IsAdminUser: boolean;
    // メールアドレス1
    MailAddress1: string;
    // メールアドレス2
    MailAddress2: string;
    // メールアドレス3
    MailAddress3: string;
}



/** */
export type SessionFunctionAuthority = {
    /***/
    FunctionCode: string;
    ///***/
    //FunctionName: string;
    /***/
    //AuthDiv: string;
    AuthDiv: codes.AuthDiv;
    /***/
    AvailabilityLevel: number;
}


/**
 * セッションユーティリティ
 */
export class Session {

    /***/
    private static loginUserInfoData: SessionLoginUserInfo;
    /***/
    private static functionAuthoritiesData: SessionFunctionAuthority[];

    /**
     * loginUserInfo
     * @param event
     */
    static get loginUserInfo(): SessionLoginUserInfo {
        try {
            if (!Session.loginUserInfoData) {
                const _loginUserInfoRaw = $('#_loginUserInfo').val() + '';
                const _loginUserInfoObject = JSON.parse(_loginUserInfoRaw);
                Session.setLoginUserInfo(_loginUserInfoObject);
            }
        } catch (e) {
            //noop
        }
        return Session.loginUserInfoData;
    }

    /**
     * loginUserInfo
     * @param event
     */
    static setLoginUserInfo(_loginUserInfoObject: any) {

        if (_loginUserInfoObject.UserId === null) { return; }
        const authDiv = codes.AuthDiv.toCodeValue(_loginUserInfoObject?.AuthDiv) || codes.AuthDiv.WORKER;
        const isAdminUser = (_loginUserInfoObject?.IsAdminUser && (_loginUserInfoObject?.IsAdminUser === true || _loginUserInfoObject?.IsAdminUser.toLowerCase() === 'true')) ? true : false;
        Session.loginUserInfoData = {
            UserId: _loginUserInfoObject.UserId || null,
            ProjectId: _loginUserInfoObject.ProjectId || null,
            CompanyId: _loginUserInfoObject.CompanyId || null,
            LoginId: _loginUserInfoObject.LoginId || '',
            StorageUserId: _loginUserInfoObject.StorageUserId || '',
            UserName: _loginUserInfoObject.UserName || '',
            DispName: _loginUserInfoObject.DispName || '',
            SignName: _loginUserInfoObject.SignName || '',
            AuthDiv: authDiv,
            EquipmentWorkOperationDiv: _loginUserInfoObject.EquipmentWorkOperationDiv || '',
            PasswordChangeNecessityFlg: _loginUserInfoObject.PasswordChangeNecessityFlg || false,
            Remarks: _loginUserInfoObject.Remarks || '',
            MailAddress1: _loginUserInfoObject.MailAddress1 || '',
            MailAddress2: _loginUserInfoObject.MailAddress2 || '',
            MailAddress3: _loginUserInfoObject.MailAddress3 || '',
            IsAdminUser: isAdminUser,
        }
    }
    /**
     * functionAuthorities
     * @param event
     */
    static get functionAuthorities(): SessionFunctionAuthority[] {
        try {
            if (!Session.functionAuthoritiesData) {
                const _functionAuthoritiesRaw = $('#_functionAuthorities').val() + '';
                const _functionAuthorities = JSON.parse(_functionAuthoritiesRaw);

                Session.setFunctionAuthorities(_functionAuthorities);

            }
        } catch (e) {
            //noop
        }
        return Session.functionAuthoritiesData;
    }

    /**
     * functionAuthorities
     * @param event
     */
    static setFunctionAuthorities(_functionAuthorities) {

        var FunctionAuthorities: SessionFunctionAuthority[] = [];
        if (_.isArray(_functionAuthorities)) {
            _functionAuthorities.forEach((f, i) => {
                const authDiv = codes.AuthDiv.toCodeValue(f.AuthDiv) || codes.AuthDiv.WORKER;
                let fa: SessionFunctionAuthority = {
                    FunctionCode: f.FunctionCode,
                    //FunctionName: f.FunctionName || '',
                    AuthDiv: authDiv,
                    AvailabilityLevel: f.AvailabilityLevel
                };
                FunctionAuthorities.push(fa);
            });
        }
        Session.functionAuthoritiesData = FunctionAuthorities;
    }

    /**
     * 
     */
    static FuncAuth = {
        /**
         * 
         */
        item: function (functionCode: string): SessionFunctionAuthority {
            let user = Session.loginUserInfo;
            let FAS = Session.functionAuthorities;
            if (!FAS) { return null; }
            let FA = FAS.find(fa => fa.FunctionCode === functionCode && fa.AuthDiv.code === user.AuthDiv.code);
            return FA || null;
        },
        /**
         * 
         */
        AvailabilityLevel: function (functionCode: string): number {
            let FA = Session.FuncAuth.item(functionCode);
            return FA?.AvailabilityLevel || 0;
        },
        /**
         * 実行可能か
         */
        isAllowed: function (functionCode: string, writeable?: boolean): boolean {
            writeable = _.isNil(writeable) ? false : writeable;
            let FA = Session.FuncAuth.item(functionCode);
            if (!FA) { return false; }
            //権限があるか
            if (FA.AvailabilityLevel === codes.AvailabilityLevel.NONE.code) {
                return false;
            }
            //書き込み権限があるかどうかのチェック
            if (writeable && (FA.AvailabilityLevel < codes.AvailabilityLevel.RW.code)) {
                return false;
            }
            return true;
        },
        /**
         * 実行不可（isAllowedの逆値）
         */
        isDenied: function (functionCode: string, writeable?: boolean): boolean {
            return !Session.FuncAuth.isAllowed(functionCode, writeable);
        }
    }


    /**
     * セッション情報の整合性チェック
     * 画面インスタンスのログイン情報とサーバーセッションのそれにアンマッチがあった場合、画面をreloadする
     */
    static checkLoginUserInfo() {
        //Util.getData('/CommonAPI/GetSessionInfo').then((source) => {
        //    if (source?.UserInfo?.UserId != Session.loginUserInfo.UserId) {
        //        //画面インスタンスのログイン情報とアンマッチがあった場合、画面をreloadする
        //        //そうすることににより、強制的に切り替え先ログインユーザーの権限に応じた画面状態になる想定
        //        window.location.reload();
        //    }
        //}).catch(() => {
        //    null;
        //});

        Util.ajax({
            url: '/CommonAPI/GetSessionInfo',
            type: 'GET'
        }, false).done(function (res, statusText, jqXHR) {
            // なぜjsonにならない？とりあえずparseする
            try {
                res = JSON.parse(res) || {};

                let source = res.Data;
                if (source?.UserInfo?.UserId != Session.loginUserInfo.UserId) {
                    //画面インスタンスのログイン情報とアンマッチがあった場合、画面をreloadする
                    //そうすることににより、強制的に切り替え先ログインユーザーの権限に応じた画面状態になる想定
                    window.location.reload();
                }
            } catch (e) {
                null;
            }
        }).fail(function (jqXHR, statusText, errorThrown) {
            null;
        });

    }
}
